import { Box } from "@mui/material";

const DEFAULT_SIZE = 26;

const ErrorIcon = ({ width = 10.425, height = 10.373 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10.425 10.373"
    >
      <g data-name="cancel/close">
        <g data-name="Group 418">
          <path
            data-name="Path 435"
            d="M4.919 4.406 8.693.631A.367.367 0 1 0 8.184.1l-.009.012L4.4 3.887.626.112a.367.367 0 0 0-.519.519l3.775 3.775L.107 8.18a.367.367 0 0 0 .519.52L4.4 4.924 8.175 8.7a.367.367 0 0 0 .519-.519z"
            transform="translate(.818 .75)"
            style={{ fill: "#fff", stroke: "#fff", strokeWidth: "1.5px" }}
          />
        </g>
      </g>
    </svg>
  );
};

const SuccessIcon = ({ width = 26, height = 26, color = "#000" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 26 26"
    >
      <g data-name="Group 21609">
        <path
          data-name="Path 15781"
          d="M13 0A13 13 0 1 1 0 13 13 13 0 0 1 13 0z"
          style={{ fill: "#f6f8fa" }}
        />
        <path
          data-name="Path 15221"
          d="M94.894 115.517a1.138 1.138 0 0 1 0 1.5l-6.029 6.683a.861.861 0 0 1-1.3.026l-3.192-3.245A1.161 1.161 0 0 1 84.3 119a.869.869 0 0 1 1.324-.053l2.53 2.586 5.391-6.016a.875.875 0 0 1 1.349 0z"
          transform="translate(-76.248 -106.508)"
          style={{ stroke: "currentColor", strokeWidth: ".25px" }}
        />
      </g>
    </svg>
  );
};

export const SuccessStatusIcon = ({
  success,
  width = DEFAULT_SIZE,
  height = DEFAULT_SIZE,
  successColor,
  errorColor,
}: {
  success: boolean;
  width?: number;
  height?: number;
  successColor?: string;
  errorColor?: string;
}) => {
  // const theme = useTheme();

  if (success) {
    return (
      <Box
        sx={(theme) => ({
          backgroundColor: successColor ?? theme.palette.success.main,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          width,
          height,
        })}
      >
        <SuccessIcon width={width} height={height} />
      </Box>
    );
  }

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: errorColor ?? theme.palette.error.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        width,
        height,
      })}
    >
      <ErrorIcon width={width * 0.5} height={height * 0.5} />
    </Box>
  );
};
